import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import { faUserSecret, faDownload } from '@fortawesome/free-solid-svg-icons';
import strings from '../../strings';
import {
  AppAndroidUrl,
  AppEBAgentLessUrl,
  AppIOSUrl,
  AppMacOSUrl,
  AppOutLookUrl,
  AppWindowsOsUrl
} from '../../routing/paths';

const childDownloadTabs = [
  {
    path: '',
    url: AppAndroidUrl,
    title: strings.navigationAppsAndroidTitle
  },
  {
    path: '',
    url: AppIOSUrl,
    title: strings.navigationAppsiOSTitle
  },
  {
    path: '',
    url: AppMacOSUrl,
    title: strings.navigationAppsMacOSTitle
  },
  {
    path: '',
    url: AppWindowsOsUrl,
    title: strings.navigationAppsWindownsOSTitle
  },
  {
    path: '',
    url: AppOutLookUrl,
    title: strings.navigationAppsOutlookTitle
  }
];

// TODO: External apps won't be apart of the react single page app routing, this needs to move somewhere else
const appRoutes = [
  {
    path: '',
    url: AppEBAgentLessUrl,
    title: strings.navigationAppsEBAgentTitle,
    icon: <FontAwesomeIcon icon={faUserSecret as IconProp} fontSize={18} />
  },
  {
    path: '',
    title: strings.navigationAppsDownloadsTitle,
    child: childDownloadTabs,
    icon: <FontAwesomeIcon icon={faDownload as IconProp} fontSize={18} />
  }
];

export default appRoutes;
